'use client';

import dynamic from 'next/dynamic';

//* Styles
import CareerTemplateStyle from './style';

//* Components
const CareerSection = dynamic(() => import('@/sections/CareerSection'));

const CareerTemplate = () => {
	return (
		<CareerTemplateStyle>
			<CareerSection />
		</CareerTemplateStyle>
	);
};

export default CareerTemplate;
